import {
  CfInsuranceQuoterProps,
  insuranceQuoterSchema,
} from "components/InsuranceQuoter/CfInsuranceQuoter/schema";
import { assert } from "superstruct";
import InsuranceQuoter, {
  InsuranceQuoterProps,
} from "components/InsuranceQuoter";
import Markdown from "react-markdown";
import React from "react";

const convertCfInsuranceQuoterProps = ({
  dataJson: {
    newCustomerDescription,
    existingCustomerDescription,
    ...dataJson
  },
}: CfInsuranceQuoterProps): InsuranceQuoterProps => {
  try {
    assert(dataJson, insuranceQuoterSchema);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn("validation InsuranceQuoter", error);
  }
  return {
    ...dataJson,
    newCustomerDescription: <Markdown>{newCustomerDescription}</Markdown>,
    existingCustomerDescription: (
      <Markdown>{existingCustomerDescription}</Markdown>
    ),
  };
};

const CfInsuranceQuoter = (dataJson: CfInsuranceQuoterProps) => {
  return <InsuranceQuoter {...convertCfInsuranceQuoterProps(dataJson)} />;
};

export default CfInsuranceQuoter;
